import React from "react";

function WhatsAppGlyph({ size = 24 }) {
  return (
    <img
      src="/whatsapp-logo.svg"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      style={{
        display: "block",
        width: size,
        height: size,
        objectFit: "contain",
        filter: "drop-shadow(0 6px 10px rgba(0,0,0,0.16))",
      }}
      onError={(event) => {
        event.currentTarget.src = "/whatsapp-logo.png";
      }}
    />
  );
}

export default WhatsAppGlyph;
